(() => {
  const SELECTOR = '.ec-edstack';

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function setupSection(section) {
    const disableMobile = section.dataset.disableMobile === 'true';
    if (disableMobile && isMobile()) {
      // Em mobile: nada de sticky/stack (fica lista normal)
      section.querySelectorAll('.ec-edstack__panel.is-sticky').forEach(p => {
        p.style.position = 'relative';
        p.style.top = 'auto';
        p.style.height = 'auto';
        p.style.marginTop = '0';
      });
      section.querySelectorAll('.ec-edstack__spacer').forEach(s => (s.style.height = '0px'));
      return;
    }

    const top = parseInt(section.dataset.topOffset || '0', 10);
    const overlap = parseInt(section.dataset.overlap || '0', 10);
    const scaleMin = parseInt(section.dataset.scaleMin || '94', 10) / 100;

    section.style.setProperty('--top', `${top}px`);
    section.style.setProperty('--overlap', `${overlap}px`);
    section.style.setProperty('--scaleMin', `${scaleMin}`);

    const panels = Array.from(section.querySelectorAll('.ec-edstack__panel.is-sticky'));
    const spacers = Array.from(section.querySelectorAll('.ec-edstack__spacer'));

    // z-index e var --idx para empilhar correto
    panels.forEach((p, idx) => {
      p.style.setProperty('--idx', idx);
    });

    function applyHeights() {
      const panelPx = Math.max(240, window.innerHeight - top);
      const spacerPx = Math.max(0, panelPx - overlap);

      // Cada painel ocupa “1 ecrã” (menos top)
      panels.forEach(p => {
        p.style.height = `${panelPx}px`;
      });

      // Spacer cria scroll real para ir “mudando o slide”
      // O último spacer não precisa de tanto, mas é ok deixar igual.
      spacers.forEach(s => {
        s.style.height = `${spacerPx}px`;
      });
    }

    applyHeights();
    window.addEventListener('resize', applyHeights, { passive: true });

    // Opcional: escala subtil nos painéis anteriores (efeito stack)
    // sem impedir scroll nem mexer no menu
    function onScroll() {
      const vh = window.innerHeight;
      panels.forEach((panel, idx) => {
        const r = panel.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, (top - r.top) / vh)); // 0 -> 1
        // Só “encolhe” quando já passou do topo
        const scale = 1 - (1 - scaleMin) * progress;
        panel.style.transform = `scale(${scale})`;
      });
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(setupSection);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
